<template>
  <v-hover v-slot:default="{ hover }">
    <div class="d-flex flex-row justify-center align-center pa-3">
      <v-btn icon small class="flex-grow-0">
        <v-icon v-if="item.isDone || item.isError" @click="remove(item.id)"
          >mdi-close</v-icon
        >
        <v-icon v-else>mdi-upload</v-icon>
      </v-btn>

      <div
        v-if="item.isError && !hover"
        class="error--text flex-grow-1 px-2 text-caption d-inline-block overflow-hidden"
        >{{ item.error_message }}</div
      >
      <div
        v-else
        class="text-caption d-inline-block text-truncate text-left flex-grow-1 pr-2"
      >
        <span>{{ item.name }}</span>
      </div>
      <div class="flex-grow-0" style="position: relative">
        <v-btn small icon v-if="!item.isDone" @click="cancelUpload(item.id)">
          <v-icon
            @mouseover="iconProgress = 'mdi mdi-close-circle'"
            @mouseout="iconProgress = 'mdi mdi-spin mdi-loading'"
          >
            {{ iconProgress }}
          </v-icon>
        </v-btn>
        <v-btn small icon v-else-if="item.isError" @click="reUpload(item.id)">
          <v-icon
            @mouseover="iconError = 'mdi mdi-replay'"
            @mouseout="iconError = 'mdi mdi-alert error--text'"
          >
            {{ iconError }}
          </v-icon>
        </v-btn>
        <div v-else>
          <v-icon class="success--text"> mdi-checkbox-marked-circle </v-icon>
        </div>
      </div>
    </div>
  </v-hover>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => ({ name: '', type: '', isDone: false }),
    },
  },
  data: () => ({
    iconProgress: 'mdi mdi-spin mdi-loading',
    iconError: 'mdi mdi-alert error--text',
  }),
  methods: {
    cancelUpload(id) {
      if (!this.item.isDone) this.$store.dispatch('upload/cancelUpload', { id })
    },
    remove(id) {
      this.$store.commit('upload/removeQueueUpload', id)
      this.$emit('click:remove')
    },
    reUpload(id) {
      if (this.item.isError) this.$store.dispatch('upload/reUpload', { id })
      this.$emit('click:reupload')
    },
  },
}
</script>

<style lang="scss" scoped></style>
